import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { shipmentApi } from 'api';

const ManualAwbModal = ({ show, onHide, shipmentId, onSuccess }) => {
  const [awbNumber, setAwbNumber] = useState('');
  const [shippingCourierName, setShippingCourierName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();

    if (!awbNumber.trim() || !shippingCourierName.trim()) {
      toast.error('All fields are required');
      return;
    }

    setIsSubmitting(true);
    try {
      await shipmentApi.manualAwb(shipmentId, {
        awb_number: awbNumber.trim(),
        shipping_courier_name: shippingCourierName.trim(),
      });
      toast.success('Manual AWB saved successfully');
      onSuccess?.();
      handleClose();
    } catch (error) {
      toast.error('Failed to save Manual AWB');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setAwbNumber('');
    setShippingCourierName('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Manual AWB</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>AWB Number *</Form.Label>
            <Form.Control
              type="text"
              value={awbNumber}
              onChange={e => setAwbNumber(e.target.value)}
              placeholder="Enter AWB number"
              isInvalid={awbNumber !== null && !awbNumber.trim()}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Shipping Courier Name *</Form.Label>
            <Form.Control
              type="text"
              value={shippingCourierName}
              onChange={e => setShippingCourierName(e.target.value)}
              placeholder="Enter shipping courier name"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ManualAwbModal;
